"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverFooter: function() {
        return _TeachingPopoverFooter.TeachingPopoverFooter;
    },
    renderTeachingPopoverFooter_unstable: function() {
        return _TeachingPopoverFooter.renderTeachingPopoverFooter_unstable;
    },
    teachingPopoverFooterClassNames: function() {
        return _TeachingPopoverFooter.teachingPopoverFooterClassNames;
    },
    useTeachingPopoverFooterStyles_unstable: function() {
        return _TeachingPopoverFooter.useTeachingPopoverFooterStyles_unstable;
    },
    useTeachingPopoverFooter_unstable: function() {
        return _TeachingPopoverFooter.useTeachingPopoverFooter_unstable;
    }
});
const _TeachingPopoverFooter = require("./components/TeachingPopoverFooter");
